import Main from 'layouts/Main';
import { BoardMember, Headline } from './components';

const Committee = () => {
    return (
        <Main>
            <Headline />
            <BoardMember />
        </Main>
    );
};

export default Committee;
